<template>
  <router-view></router-view>
</template>

<script>
// import Layout from "../src/components/Layout.vue";
export default {
  name: "App",
};
</script>

<style lang="scss" scoped>
@import url("./style/config.scss");
@import url("./style/vant.scss");
</style>>
